import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useGetFeatureFlagsQuery } from "services/common/featureFlagService";
import { setTranslationServiceStatus } from "features/translationServiceSlice";
import { TRANSPERFECT_SCRIPT_URL, TRANSPERFECT_SCRIPT_DATA_OLJS } from "utilities/Constant";

const SCRIPT_ID = "transperfect-globallink-script";

export const useTranslationScript = (): void => {
  const dispatch = useDispatch();
  const { data: featureFlag } = useGetFeatureFlagsQuery();

  useEffect(() => {
    if (!featureFlag?.preferredLanguageEnabled) {
      return;
    }

    if (document.getElementById(SCRIPT_ID)) {
      return;
    }

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.type = "text/javascript";
    script.src = TRANSPERFECT_SCRIPT_URL;
    script.setAttribute("referrerpolicy", "no-referrer-when-downgrade");
    script.setAttribute("data-oljs", TRANSPERFECT_SCRIPT_DATA_OLJS);

    script.onload = () => {
      dispatch(setTranslationServiceStatus("loaded"));
    };

    script.onerror = () => {
      dispatch(setTranslationServiceStatus("failed"));
    };

    document.head.insertBefore(script, document.head.firstChild);
  }, [featureFlag?.preferredLanguageEnabled, dispatch]);
};
